var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class ValidationErrorGroup {
  constructor(_data) {
    /**
     */
    __publicField(this, "Args");
    /**
     */
    __publicField(this, "LineIndex");
    /**
     */
    __publicField(this, "TotalErrorCount");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ValidationErrorGroup
     */
    __publicField(this, "$type", "V1.Cesop.Periods.Validation.Source.ValidationErrorGroup");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Args"] && _data["Args"].constructor === Array) {
        this.Args = [];
        for (let item of _data["Args"]) {
          this.Args.push(item);
        }
      }
      this.LineIndex = _data["LineIndex"];
      this.TotalErrorCount = _data["TotalErrorCount"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["$type"] = this.$type;
    if (this.Args && this.Args.constructor === Array) {
      _data["Args"] = [];
      for (let item of this.Args) {
        _data["Args"].push(item);
      }
    }
    _data["LineIndex"] = this.LineIndex;
    _data["TotalErrorCount"] = this.TotalErrorCount;
    return _data;
  }
}
